import getShorterText from "Common/componentUtils/getShorterText";
import { mapGeometryTypeIconMap, mapGeometryTypeLocale } from "Common/dictionaries/mapGeometryType";
import { themeVariables } from "Components/theme";
import toString from "lodash/toString";
import React, { useMemo } from "react";
const mainDataContainerStyle = {
    display: "grid",
    alignContent: "center"
};
const geometryTypeNameStyle = {
    fontSize: themeVariables["font-size-small"],
    color: themeVariables["text-muted"]
};
const displayNameStyle = {
    paddingTop: 2,
    paddingBottom: 6,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    lineHeight: themeVariables["line-height-medium"]
};
export default function GeometryLabel(props) {
    const labelRootStyle = useMemo(() => ({
        ...(props.style || {}),
        display: "grid",
        gridTemplateColumns: "auto 1fr",
        gridTemplateRows: "1fr",
        boxSizing: "border-box"
    }), [props.style]);
    const imageContainerStyle = useMemo(() => props.imgSize
        ? {
            width: props.imgSize,
            height: props.imgSize,
            minHeight: props.imgSize,
            minWidth: props.imgSize,
            marginRight: 10,
            borderRadius: "50%",
            backgroundColor: themeVariables["gray-450"],
            display: "grid",
            alignContent: "center",
            justifyContent: "center"
        }
        : undefined, [props.imgSize]);
    const imgIconStyle = useMemo(() => props.imgSize
        ? {
            fontSize: Math.round(Math.log(props.imgSize) * 5.5),
            color: themeVariables["gray-400"]
        }
        : undefined, [props.imgSize]);
    if (!props.data)
        return null;
    const displayName = props.data.Name;
    const resultImgIcon = Boolean(props.imgSize) &&
        props.data.MapGeometryType &&
        mapGeometryTypeIconMap[props.data.MapGeometryType];
    return (React.createElement("div", { className: props.className, style: labelRootStyle },
        resultImgIcon && (React.createElement("div", { style: imageContainerStyle }, resultImgIcon && React.createElement("i", { className: resultImgIcon, title: "", style: imgIconStyle }))),
        !props.onlyIcon && (React.createElement("div", { style: mainDataContainerStyle },
            displayName && (React.createElement("div", { style: displayNameStyle, title: toString(displayName) }, getShorterText(displayName, props.titleMaxLength))),
            props.data.MapGeometryType && (React.createElement("div", { style: geometryTypeNameStyle }, mapGeometryTypeLocale[props.data.MapGeometryType]))))));
}
GeometryLabel.defaultProps = {
    imgSize: 50,
    titleMaxLength: 100
};
